<template>
  <div
    v-if="
      supplier &&
      supplier.greenfins_membership_level &&
      supplier.greenfins_membership_level !== 'none'
    "
    class="p-6 rounded min-h-32 sm:min-h-24"
    style="background-color: #f5f5f5"
  >
    <div class="flex sm:flex-wrap">
      <div class="flex-none pr-6 sm:w-full">
        <div class="flex items-center sm:mx-auto">
          <img
            class="green-fins"
            width="64"
            height="64"
            :src="`/img/GF_Stamp_${uppercaseFirstLetter(
              supplier.greenfins_membership_level
            )}.png`"
            alt="green fins"
          />
          <div
            class="flex-1 fs-16 font-medium lg:hidden md:hidden sm:pl-4 capitalize"
          >
            <span>
              Green Fins {{ supplier.greenfins_membership_level }} Member
            </span>
            <a
              target="_blank"
              class="text-secondary fs-12 block"
              title="Learn more about Green Fins"
              href="https://www.zubludiving.com/conservation/green-fins"
              >Learn more about Green Fins
            </a>
          </div>
        </div>
      </div>

      <div class="flex-1">
        <h4
          class="fs-20 font-medium lg:visible md:visible sm:hidden capitalize"
        >
          Green Fins {{ supplier.greenfins_membership_level }} Member
        </h4>

        <p class="mt-2 sm:mt-0">
          <span class="sm:hidden">
            This resort is committed to sustainable practices. Staying here
            helps protect the oceans and our natural world.
          </span>
          <a
            target="_blank"
            class="text-secondary sm:hidden font-medium whitespace-no-wrap"
            title="Learn more about Green Fins"
            href="https://www.zubludiving.com/conservation/green-fins"
            >Learn more about Green Fins</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["resortId"],
  data() {
    return {
      supplier: null,
    };
  },
  mounted() {
    window.fetchSupplierInfo(this.resortId).then((res) => {
      this.supplier = res.supplier;
    });
  },
  methods: {
    uppercaseFirstLetter(text) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
  },
};
</script>
